export default "__VITE_ASSET__DT0hjx04__"